import arrow from "../../assets/img/icon/Pfeil.svg";

function DoubleArrowDown(props) {
    return (
        <div className={"DoubleArrowDown " + props.className.toString()} onClickCapture={props.onClick} id={props.id}>
            <p>{props.children}</p>
            <div className="DoubleArrowDown-Arrows">
                <img src={arrow} />
                <img src={arrow} />
            </div>
        </div>
    );
}

export default DoubleArrowDown;